var _path, _path2, _path3, _path4;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Performance = function Performance(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      className: "tw-fill-current",
      opacity: "0.4",
      d: "M12.9254 19.2859H20.0129V8.61094C20.0129 6.68594 18.4379 5.02344 16.4254 5.02344C14.5004 5.02344 12.8379 6.59844 12.8379 8.61094V19.2859H12.9254Z",
      fill: "none"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      className: "tw-fill-current",
      d: "M16.4287 12C18.3617 12 19.9287 10.433 19.9287 8.5C19.9287 6.567 18.3617 5 16.4287 5C14.4957 5 12.9287 6.567 12.9287 8.5C12.9287 10.433 14.4957 12 16.4287 12Z",
      fill: "none"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      className: "tw-fill-current",
      opacity: "0.4",
      d: "M7.5875 19.2863C9.5125 19.2863 11.175 17.7113 11.175 15.6988V12.1988C11.175 10.2738 9.6 8.61133 7.5875 8.61133C5.6625 8.61133 4 10.1863 4 12.1988V15.7863C4.0875 17.7113 5.6625 19.2863 7.5875 19.2863Z",
      fill: "none"
    })), _path4 || (_path4 = /*#__PURE__*/_jsx("path", {
      className: "tw-fill-current",
      d: "M7.58691 19.2871C9.51991 19.2871 11.0869 17.7201 11.0869 15.7871C11.0869 13.8541 9.51991 12.2871 7.58691 12.2871C5.65392 12.2871 4.08691 13.8541 4.08691 15.7871C4.08691 17.7201 5.65392 19.2871 7.58691 19.2871Z",
      fill: "none"
    }))]
  });
};
export default Performance;